var carrusel = function (slider) {
    var slides = [].slice.call(slider.querySelectorAll('.carrusel-elemento')), posicion = 0, total = slides.length, retardoGlobal = parseInt(slider.getAttribute('data-retardo') || '5000'), timeout = 0, automatico = true;
    var avanza = function () {
        if (automatico) {
            slider.classList.remove('rapido');
            slider.setAttribute('aria-live', 'off');
            actualizaPosicion((posicion + 1) % total);
        }
    };
    var actualizaPosicion = function (i) {
        slides[posicion].classList.remove('activa');
        posicion = i;
        slides[posicion].classList.add('activa');
        var retardo = parseInt(slides[i].getAttribute('data-retardo') || '0', 10) || retardoGlobal;
        timeout = window.setTimeout(avanza, retardo);
    };
    var pausa = function () {
        automatico = false;
        clearTimeout(timeout);
    };
    var reanuda = function () {
        automatico = true;
        actualizaPosicion(posicion);
    };
    reanuda();
    slider.addEventListener('focusin', function (e) {
        pausa();
        if (e.target instanceof HTMLElement) {
            var li = e.target.closest('.carrusel-elemento');
            slider.setAttribute('aria-live', 'polite');
            if (li instanceof HTMLLIElement) {
                slider.classList.add('rapido');
                actualizaPosicion(slides.indexOf(li));
            }
        }
    }, true);
    slider.addEventListener('mouseenter', pausa);
    slider.addEventListener('focusout', reanuda);
    slider.addEventListener('mouseleave', reanuda);
};
export default carrusel;
